import React from "react";
import axios from "axios";
import Bloodhound from 'bloodhound-js';
import 'typeahead.js';
import $ from "jquery";
import * as Bootstrap from 'bootstrap/dist/js/bootstrap.js';
import {
    sendToLocalStorage
} from './Utilities';
import Pagination from './Pagination';
import FavoriteModal from './FavoriteModal';

class FavoriteCard extends React.Component{
    constructor(props){
        super(props);

        var reportData = {};
        reportData['ID'] = this.props.ID;
        reportData['Name'] = this.props.Name;
        reportData['Description'] = this.props.Description;
        reportData['Color'] = this.props.Color;
        reportData['Hash'] = this.props.Hash;
        reportData['Filters'] = this.props.Filters;

        this.CurrentFavorite = React.createRef();

        this.state = {
            report: reportData
        };
    }

    openFavoriteModal(e, obj){
        e.preventDefault();
        this.updateLocalStorage(this.props.Filters);

        var options = {};   
        var myModal = new Bootstrap.Modal($("#FavoriteReportModal-"+this.props.ID), options);
        myModal.show(true);
    }

    confirmDelete(e, obj){
        e.preventDefault();

        var data = {};
        data.Action = "/dashboard/reports/deleteFavoriteReport/"+this.props.ID+"?Next=/dashboard/reports/favorites";
        data.Title = "Confirm Deletion of this Favorite";
        data.Text = "<p>Are you sure you want to delete the favorite report <strong>"+this.props.Name+"</strong>?</p>";
        data.Warning = "This action cannot be undone.";

        var options = {};  
        window.populateDeleteModal(data);      
        var myModal = new Bootstrap.Modal($("#ConfirmDeleteModal"), options);
        myModal.show(true);
    }

    viewFavoriteReport(e, obj){
        e.preventDefault();
        this.updateLocalStorage(this.props.Filters);
        return window.location.href = "/dashboard/reports/setCurrentFavoriteReport/"+this.props.ID+"?Next=/dashboard/reports/results";
    }

    updateLocalStorage(filters){
        sendToLocalStorage("report_data", filters);
    }

    render(){
        var cardID = "Favorite"+this.props.ID;

        return(
            <div className="col" key={cardID}>
                <div className="card" id={cardID} style={{borderLeftColor: this.props.Color}}>
                    <div className="card-body">
                        <a href="#" onClick={(e) => this.viewFavoriteReport(e, this)}>
                            <h5 className="card-title">{this.props.Name}</h5>
                            <p className="card-text">{this.props.Description}</p>
                        </a>
                        <div className="fave-buttons">
                            <div className="fave-button view">
                                <a href="#">
                                    <button className="btn btn-success" onClick={(e) => this.viewFavoriteReport(e, this)}
                                    style={{backgroundColor: this.props.Color, borderColor: this.props.Color}}>View</button>
                                </a>
                            </div>
                            <div className="fave-button edit">    
                                <a href="#">
                                    <button className="btn btn-success" onClick={(e) => this.openFavoriteModal(e, this)}
                                    style={{backgroundColor: this.props.Color, borderColor: this.props.Color}}>Edit</button>
                                </a>
                            </div>
                             <div className="fave-button delete">    
                                <a href="#">
                                    <button className="btn btn-danger" onClick={(e) => this.confirmDelete(e, this)}>Delete</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <FavoriteModal key={this.props.ID} report={this.state.report} values={this.props.Filters} />
            </div>
        );
    }
}

class FavoritesPage extends React.Component {
    constructor(props){
        super(props);
        this.myRef = React.createRef();
        this.state = {
        	"url": "react/getFavoriteReports?turnoffdebug=1",
            "favorites": null,
            "favoritesLoaded": false,
            "favoritesMatches": false,
            "next": 0,
            "count": 0,
            "editReportID": null
        };
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.favorites && !this.state.favoritesLoaded) {
            this.setState({
                favoritesLoaded: true
            });
            this.createTypeahead();          
        }   
    }

    createTypeahead(){
        var favorites = new Bloodhound({
            local: this.state.favorites,
            limit: 10,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });
        favorites.initialize();

        $(this.myRef.current).typeahead(
            {
              hint: true,
              highlight: true,
              minLength: 1
            },
            {
                name: 'favorites',
                displayKey: 'name',
                multiple: true,
                templates: {
                    suggestion: function (data) {
                        return '<div class="favorite" data-favorite-id="'+data.ID+'">'+data.Name+'</div>';
                    }
                },
                source: favorites.ttAdapter()
            }
        );
    }

    getData(){
        axios.get(this.state.url).then(response => this.formatData(response.data));
    }

    formatData(data){
        this.setState({
            favorites: data.items,
            count: data.TotalCount
        });
    }

    onKeyPressed(e){    
    	var clue = e.target.value;
        const matches = this.state.favorites.filter(function(favorite){
            return favorite.Name.toLowerCase().includes(clue.toLowerCase());
        });

        this.setState({
            favoritesMatches: matches
        });
    }

    paginationHandler(next){
        this.setState({
            next: next,
        });
    }

    handleCurrent = (obj) => {
        console.log(obj);
    }

    render() {
        var inputStyle = {
            'width': '100%',
        }

        var favorites = {};
        var favoritesCount = 0;
        if(this.state.favoritesMatches) {
            favorites = this.state.favoritesMatches;
            favoritesCount = Object.keys(favorites).length;
        } else if(this.state.favorites) {
            favorites = this.state.favorites;
            favoritesCount = this.state.count;
        }

        //only display 11 per page. handles paging
        if(Object.keys(favorites).length > this.props.perPage) {
            favorites = favorites.slice(this.state.next, (this.state.next + this.props.perPage));
        }

        var parent = this; //(for use within loop)

        return(
            <div>
                <div className="row mb-3">
                    <div className="col-md-6"></div>          
                    <div className="col-md-6 row search-row">
                        <div className="col-md-3">
                            <label className="col-form-label favorites-search-label">
                                <span className="mdi mdi-magnify"></span> Search
                            </label>
                        </div>
                        <div className="col-md-9 typeahead-holder">
                            <input type="text" id="favorite-selector" ref={this.myRef} onKeyUp={(e) => this.onKeyPressed(e)} style={inputStyle} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="row row-cols-1 row-cols-lg-6 row-cols-md-3 row-cols-sm-2 g-2 card-overview favorites">

                            <div className="col">
                                <div className="card" id="AddFavoriteCard">
                                    <div className="card-header bg-secondary py-3">
                                        <div className="card-widgets">
                                            <a href="#" data-toggle="remove"><i className="mdi mdi-close"></i></a>
                                        </div>
                                        <h5 className="card-title mb-0 text-white">Tip</h5>
                                    </div>
                                    <div id="cardCollpase5" className="collapse show">
                                        <div className="card-body text-muted font-14">
                                            <h5>Add a new favorite</h5>
                                            <p>Create a report first, and then favorite it.</p>
                                            <a href="dashboard/reports?clear=report_data" className="btn btn-primary mt-2 waves-effect waves-light">
                                                <i className="fas fa-plus-circle mr-5"></i>
                                                Create report
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {Object.entries(favorites).map(function(obj, key) {
                               {return <FavoriteCard key={key} 
                                                     ID={obj[1].ID} Name={obj[1].Name} 
                                                     Description={obj[1].Description} 
                                                     Color={obj[1].Color} 
                                                     Hash={obj[1].Hash}
                                                     Filters={obj[1].Filters}

                                        />
                                ;}
                            })}
                        </div>
                    </div>
                </div>
                <div className="table-controls">
                    {/*<Totals next={this.state.next} type={this.props.type} />*/}
                    <Pagination perPage={this.props.perPage} sendToPage={this.paginationHandler.bind(this)} 
                                count={favoritesCount} 
                                />
                </div>
                
            </div>
        );
    }
}

FavoritesPage.defaultProps = {
    perPage: 11
};

export default FavoritesPage;

